// Prediction window: predictions open this many ms before match starts
export const PREDICTION_WINDOW_MS = 8 * 60 * 60 * 1000; // 8 hours

// Polling intervals
export const MATCH_POLL_INTERVAL_MS = 60000; // 1 minute
export const LIVE_POLL_INTERVAL_MS = 3000; // 3 seconds
export const LEADERBOARD_POLL_INTERVAL_MS = 10000; // 10 seconds

// Prediction bounds (slider range)
export const PREDICTION_MIN = 50;
export const PREDICTION_MAX = 600;

// Reward pools per match (total, divided equally among winners)
export const EXACT_REWARD_POOL = 5000;
export const CLOSE_REWARD_POOL = 7000;
